import axios from "axios"
import baseUrl from "./base"

const authApi = {
  fetchNotifikasi: async (token) => {
    return await axios.get(`${baseUrl}/api/notifications/get`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  sendNotifikasi: async (token, data) => {
    return await axios.post(`${baseUrl}/api/notifications/send`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  sendNotifikasiNoAuth: async (data) => {
    return await axios.post(`${baseUrl}/api/no-auth/notifications/send`, data)
  },
  clearNotifikasi: async (token, data) => {
    return await axios.delete(`${baseUrl}/api/notifications/clear`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  }
}

export default authApi